import { RootState } from '../types'

export const getMainOrderSelector = (state: RootState) => state.order